import { render, staticRenderFns } from "./AiMatchSponsor.vue?vue&type=template&id=4b6d1f89&scoped=true&"
import script from "./AiMatchSponsor.vue?vue&type=script&lang=js&"
export * from "./AiMatchSponsor.vue?vue&type=script&lang=js&"
import style0 from "./AiMatchSponsor.vue?vue&type=style&index=0&id=4b6d1f89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6d1f89",
  null
  
)

export default component.exports